import type { MasterOption } from './types';

interface RawMasterRow {
  _id?: string;
  name?: string;
  aliasName?: string;
  label?: string;
}

interface RawProductRow {
  _id?: string;
  number?: string;
}

interface RawUserRow {
  _id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
}

/** Maps a system-master list (shape: { _id, name | aliasName | label }) to MasterOption. */
export function toMasterOptions(rows: unknown): MasterOption[] {
  if (!Array.isArray(rows)) return [];
  return (rows as RawMasterRow[])
    .filter((row) => row && row._id)
    .map((row) => ({ _id: String(row._id), label: row.name || row.aliasName || row.label || '' }));
}

/** Maps the /all-open-products response (shape: { _id, number }) to MasterOption. */
export function toProductOptions(rows: unknown): MasterOption[] {
  if (!Array.isArray(rows)) return [];
  return (rows as RawProductRow[]).filter((row) => row && row._id).map((row) => ({ _id: String(row._id), label: row.number || '' }));
}

/** Maps the company-user list to MasterOption, labelling each row with its full name and falling back to the email. */
export function toUserOptions(rows: unknown): MasterOption[] {
  if (!Array.isArray(rows)) return [];
  return (rows as RawUserRow[])
    .filter((row) => row && row._id)
    .map((row) => ({ _id: String(row._id), label: [row.firstName, row.lastName].filter(Boolean).join(' ') || row.email || '' }));
}
